import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shouldRender", "password", "publicAccessRules", "publicAccessRulesEnabled", "isSSOEnabled"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PublicAccessRuleTypes } from '../constants/PublicAccessRuleTypes';
import { getContentAccessTypeTagI18nKeyFromContent } from '../utils/contentAccessTypeTag';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentAccessTypeTag(props) {
  const {
      shouldRender,
      password,
      publicAccessRules,
      publicAccessRulesEnabled,
      isSSOEnabled
    } = props,
    $spaceStyleProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    i18nKey: contentAccessTypeTagI18nKey
  } = getContentAccessTypeTagI18nKeyFromContent({
    password,
    publicAccessRules,
    publicAccessRulesEnabled,
    isSSOEnabled
  });
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tag, Object.assign({}, $spaceStyleProps, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: contentAccessTypeTagI18nKey
    })
  }));
}
ContentAccessTypeTag.propTypes = {
  shouldRender: PropTypes.bool.isRequired,
  password: PropTypes.string,
  publicAccessRules: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(Object.values(PublicAccessRuleTypes)).isRequired,
    ids: PropTypes.arrayOf(PropTypes.number).isRequired,
    wallPreviewEnabled: PropTypes.bool
  })).isRequired,
  publicAccessRulesEnabled: PropTypes.bool,
  isSSOEnabled: PropTypes.bool,
  className: PropTypes.string
};
export default ContentAccessTypeTag;